module.exports = __webpack_public_path__ + "static/media/ICONS_VIAS DE EMBARQUE.23b46b1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ICONS/ICONS_VIAS DE EMBARQUE.svg
// module id = 491
// module chunks = 0